module.exports = __webpack_public_path__ + "img/bilibili.46331c40.png";